<template>
  <component
    :is="!label ? QIcon : 'div'"
    class="tw-relative hover:tw-cursor-pointer"
    :name="name"
    color="primary"
    size="24px"
    v-bind="$attrs"
  >
    {{ label }}
    <c-tooltip>
      <slot />
    </c-tooltip>
  </component>
</template>

<script setup>
import { QIcon } from "quasar";

defineProps({
  name: {
    type: String,
    default: "fa-duotone fa-circle-info",
  },
  label: {
    type: String,
    default: "",
  },
});
</script>
